import React, { Fragment, useState, useEffect } from "react";
import Moment from "react-moment";

import PostCommentsReplyItem from "./PostCommentsReplyItem";

const PostCommentsItem = ({
  replies,
  user,
  profile,
  profile_channelid,
  id,
  comment: {
    _id,
    role,
    channelid,
    avatar,
    text,
    gif,
    firstname,
    lastname,
    jobtitle,
    verified_account,
    comment_deleted,
    date,
  },
  deleteComment,
  AddReply,
  DeleteReply,
  setReportedUser,
  setShowReportUser,
  setReplyComment,
  setReplyToComment,
  setPostReply,
  Reply,
  setBannedUser,
  setShowBanUserComment,
  setShowBanUserReply,
  truncate,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showReply, setShowReply] = useState(false);

  const maxLength = 100;

  return (
    <Fragment>
      <div className="comment-alt">
        <div className="comment-background-top">
          <div className="comment-user">
            <div className="comment-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                alt="avatar"
                className="comment-avi"
              />
            </div>
            <ul className="post-user-items">
              <div className="align-center">
                <li
                  className={`item-font ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  } bold`}
                >
                  {channelid}{" "}
                </li>
                {profile.channelid === channelid ? (
                  <i class="fa-solid fa-crown translate-y mx-5 gold"></i>
                ) : (
                  ""
                )}
                {verified_account && (
                  <div>
                    <i
                      class={`fa-regular fa-circle-check fa-sm ${
                        role && role === "innovator"
                          ? "green"
                          : role && role === "mentor"
                          ? "red"
                          : role && role === "employer"
                          ? "blue"
                          : ""
                      } mr-5`}
                    ></i>
                  </div>
                )}
              </div>
              <li className="stream-item bold">
                {firstname} {channelid === "roland" ? "" : lastname}
              </li>
              <li className="stream-item">{jobtitle}</li>
            </ul>
          </div>
          <div className="comment-date">
            <Moment format="MM/DD/YYYY">{date}</Moment>
          </div>
          <div className="comment-header-container">
            {showModal && (
              <div className="modal">
                <ul className="modal-items">
                  {user.channelid !== channelid &&
                    user.channelid === profile.channelid && (
                      <li
                        onClick={() => {
                          setShowBanUserComment({
                            submit: true,
                            confirm: false,
                          });
                          setBannedUser({
                            ...setBannedUser,
                            post_id: id,
                            comment_id: _id,
                            role,
                            channelid: channelid,
                            avatar: avatar,
                            firstname: firstname,
                            lastname: lastname,
                            text,
                            gif,
                          });
                        }}
                        className="modal-item"
                      >
                        <i className="fas fa-ban mx-5 red"></i>
                        Ban
                      </li>
                    )}
                  {user.channelid !== channelid && (
                    <li
                      className="modal-item"
                      onClick={() => {
                        setShowReportUser({ submit: true, confirm: false });
                        setReportedUser({
                          role,
                          channelid,
                          avatar,
                          firstname,
                          lastname,
                          text,
                          image: "",
                          video: "",
                          gif: "",
                        });
                      }}
                    >
                      <i
                        className={`fas fa-flag mx-5 ${
                          role && role === "innovator"
                            ? "green"
                            : role && role === "mentor"
                            ? "red"
                            : role && role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      ></i>
                      Report
                    </li>
                  )}
                  {user.channelid === channelid && (
                    <li
                      onClick={() => {
                        deleteComment(id, _id, profile_channelid);
                      }}
                      className="modal-item"
                    >
                      <i
                        className={`fas fa-times mx-5 ${
                          role && role === "innovator"
                            ? "green"
                            : role && role === "mentor"
                            ? "red"
                            : role && role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      ></i>
                      Delete
                    </li>
                  )}
                  {user.channelid !== channelid &&
                    user.channelid === profile.channelid && (
                      <li
                        onClick={() => {
                          deleteComment(id, _id, profile_channelid);
                        }}
                        className="modal-item"
                      >
                        <i
                          className={`fas fa-times mx-5 ${
                            role && role === "innovator"
                              ? "green"
                              : role && role === "mentor"
                              ? "red"
                              : role && role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        ></i>
                        Delete
                      </li>
                    )}
                </ul>
              </div>
            )}
            {!comment_deleted && (
              <i
                onClick={() => {
                  if (showModal) {
                    setShowModal(false);
                  } else {
                    setShowModal(true);
                  }
                }}
                className={`fa-solid fa-ellipsis ${
                  role && role === "innovator"
                    ? "green"
                    : role && role === "mentor"
                    ? "red"
                    : role && role === "employer"
                    ? "blue"
                    : ""
                }`}
              ></i>
            )}
          </div>
        </div>
        <div className="comment-footer">
          <div className="comment-background-bottom">
            {gif !== "" && (
              <img src={gif} alt="media" className="reported-media-alt" />
            )}
            <div className="comment-text-container">
              {text !== "" && <p className="post-text">{text}</p>}
            </div>
            <div className="comment-action-buttons">
              {/* <div className="comment-left-buttons">
                <i
                  className={`far fa-thumbs-up mx-5 ${
                    role && role === "innovator"
                      ? "green"
                      : role && role === "mentor"
                      ? "red"
                      : role && role === "employer"
                      ? "blue"
                      : ""
                  }`}
                ></i>
                <span className="white"></span>
              </div> */}
              {!comment_deleted && (
                <div
                  className="comment-right-buttons"
                  onClick={() => {
                    if (showReply) {
                      setShowReply(false);
                    } else {
                      setShowReply(true);
                    }
                  }}
                >
                  <i
                    className={`fas fa-reply mx-5 ${
                      role && role === "innovator"
                        ? "green"
                        : role && role === "mentor"
                        ? "red"
                        : role && role === "employer"
                        ? "blue"
                        : ""
                    }`}
                  ></i>
                  {!showReply && <span className="white">Reply</span>}
                  {showReply && <span className="white">Hide Reply</span>}
                </div>
              )}
            </div>
          </div>
          <div className="reply-container">
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (Reply.text !== "") {
                  AddReply(id, _id, profile_channelid, Reply.text, Reply.gif);
                }
                setPostReply({ text: "", gif: "" });
              }}
              className="comment-reply-input-container"
            >
              <div className="comment-avi-container">
                <div className="comment-avi"></div>
              </div>
              {showReply && (
                <div className="comment-reply-input-hidden">
                  <input
                    type="text"
                    className="comment-reply-input"
                    name="reply"
                    maxLength={100}
                    value={Reply.text}
                    onChange={(e) =>
                      setPostReply({ ...Reply, text: e.target.value })
                    }
                    placeholder="Enter your reply here..."
                  />
                  {user &&
                    user.founding_supporter_type !== "Good" &&
                    user.founding_supporter_type !== "" && (
                      <div
                        className="gif-button-container red"
                        onClick={() => {
                          setReplyToComment({
                            id,
                            commentId: _id,
                            role,
                            channelid,
                            avatar,
                            firstname,
                            lastname,
                            jobtitle,
                            text: text !== "" ? text : "",
                            gif: gif !== "" ? gif : "",
                          });
                          setReplyComment(true);
                        }}
                      >
                        <p className="gif-button">GIF</p>
                      </div>
                    )}
                  <p className="white character-counter-comment">
                    {Reply.text.split("").length}/{maxLength} characters
                  </p>
                  <button
                    className={`comment-reply-input-button ${
                      role && role === "innovator"
                        ? "background-green"
                        : role && role === "mentor"
                        ? "background-red"
                        : "background-blue"
                    }`}
                  >
                    <i className="far fa-comments"></i>
                  </button>
                </div>
              )}
            </form>
            {replies && replies.length > 0 && replies.length > 5 && truncate
              ? replies
                  .map((reply) => {
                    if (reply.comment_id.toString() === _id) {
                      return (
                        <PostCommentsReplyItem
                          key={reply._id}
                          id={id}
                          reply={reply}
                          commentId={_id}
                          profile={profile}
                          profile_channelid={profile.channelid}
                          user={user}
                          DeleteReply={DeleteReply}
                          setReportedUser={setReportedUser}
                          setShowReportUser={setShowReportUser}
                          setBannedUser={setBannedUser}
                          setShowBanUserReply={setShowBanUserReply}
                        />
                      );
                    }
                  })
                  .splice(0, 5)
              : replies.map((reply) => {
                  if (reply.comment_id.toString() === _id) {
                    return (
                      <PostCommentsReplyItem
                        key={reply._id}
                        id={id}
                        reply={reply}
                        commentId={_id}
                        profile={profile}
                        profile_channelid={profile.channelid}
                        user={user}
                        DeleteReply={DeleteReply}
                        setReportedUser={setReportedUser}
                        setShowReportUser={setShowReportUser}
                        setBannedUser={setBannedUser}
                        setShowBanUserReply={setShowBanUserReply}
                      />
                    );
                  }
                })}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default PostCommentsItem;
